import { Component, ElementRef, NgZone, OnInit, Renderer2, ViewChild } from '@angular/core';
import 'slick-carousel';
import "datatables.net";
import "file-saver";
import 'dom-to-image';
import { ApplicationService } from './services/application.service';
import { AvbobConnectData } from './services/interface.service';
import { MessageService } from './services/message.service';
import { OAuthService } from 'angular-oauth2-oidc';
import { authConfig } from './auth.config';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-connect',
  templateUrl: './app.component.html'
})

export class AppComponent implements OnInit {

  showCallbackButton = true;
  receivedMessage: string = ''; // Property to display the received message
  platformstatus: string = "yes";
  myIframeSource: string = "";

  @ViewChild('myIframe') myIframe!: ElementRef;

  constructor(    
    public applicationService: ApplicationService,
    public data: AvbobConnectData,
    public messageService: MessageService,
    private ngZone: NgZone, // Add NgZone to the constructor
    private renderer: Renderer2,
    private sanitizer: DomSanitizer
  ) {

  }

  ngOnInit() {
    window.addEventListener('webChatClosed', () => {
      this.platformstatus = "yes";
    });
    window.addEventListener('message', (event) => {
      // Security check for origin      
      if (event.origin === 'https://campaigns.xpressinformation.co.za/' || event.origin === 'https://campaigns.xpressinformation.co.za') {
        this.ngZone.run(() => {          
          var message = event.data?.content;
          if (!message) {
            message = event.data;
          }          
          switch (message) {
            case 'AVAOpen':
              this.renderer.setStyle(this.myIframe.nativeElement, 'width', '450px');
              this.renderer.setStyle(this.myIframe.nativeElement, 'height', '768px');
              this.renderer.setStyle(this.myIframe.nativeElement, 'border-radius', '0');
              break;
            case 'AvaOpen':
              this.renderer.setStyle(this.myIframe.nativeElement, 'width', '450px');
              this.renderer.setStyle(this.myIframe.nativeElement, 'height', '768px');
              break;
            case 'AVAClosed':
              this.renderer.setStyle(this.myIframe.nativeElement, 'width', '105px');
              this.renderer.setStyle(this.myIframe.nativeElement, 'height', '105px');
              this.renderer.setStyle(this.myIframe.nativeElement, 'align-items', 'center');
              this.renderer.setStyle(this.myIframe.nativeElement, 'border-radius', '50%');
              break;
            case 'AvaClose':
              this.renderer.setStyle(this.myIframe.nativeElement, 'width', '150px');
              this.renderer.setStyle(this.myIframe.nativeElement, 'height', '150px');
              break;
            case 'Callback':              
              this.renderer.setStyle(this.myIframe.nativeElement, 'display', 'none');
              // Open the genyses app here
              this.platformstatus = "no";
              this.applicationService.loadGenesysChat();
              break;
            default:
              console.log('Unhandled message:', message);
          }
          this.receivedMessage = message;
        });
      }
    });
  }

  showIframeAndSendMessage(): void {
    this.renderer.setStyle(this.myIframe.nativeElement, 'display', 'block');
    this.myIframe.nativeElement.contentWindow.postMessage(
      { content: 'AVAOpen' },
      'https://campaigns.xpressinformation.co.za'
    );
  }

  get user(): any {
    return this.data.UserInfo;
  }

  get env(): string[] {
    let environment = "";
    if (this.applicationService.environment && this.applicationService.environment == "avbob development") {
      environment = "construction zone";
    }
    else if (this.applicationService.environment && this.applicationService.environment == "quality assurance") {
      environment = "quality assurance";
    }
    if (environment) {
      return environment.split('');
    }
    return null;
  }

  get showIdle(): boolean {
    if (this.applicationService.idleState > 1) {
      return true;
    }
  }

  get isOnline(): boolean {
    return window.navigator.onLine;
  }

  continue() {
    this.applicationService.resetIdle();
  }

  get platform(): number {
    return this.applicationService.applicationMode;
  }

  get isKiosk(): boolean {
    return this.applicationService.isKiosk;
  }

  get showCallbackPanel(): boolean {
    let enableCallMe = sessionStorage.getItem("enableCallMe");
    if (enableCallMe && enableCallMe == "yes") {
      return true;
    }
    return false;
  }

  get environment(): string {
    return this.applicationService.environment;
  }

  doCallBack() {
    this.applicationService.updateClientLead();
    this.showCallbackButton = false;
  }

  get settingsLoaded(): boolean {
    return this.applicationService.settingsLoaded;
  }

  public selfServiceAVAUrl(): string  {
    console.log(this.applicationService.selfServiceAVAUrl);
    //return this.sanitizer.bypassSecurityTrustResourceUrl(this.applicationService.selfServiceAVAUrl);
    return this.applicationService.selfServiceAVAUrl;
  }

}
